/**
 * Maps a sorted column string (e.g. '-ro_number') to react-data-table-component
 * `defaultSortFieldId` and `defaultSortAsc` props.
 *
 * @param {string} sortedColumn - The sort value, optionally prefixed with '-' for descending.
 * @param {Array} columns - The columns array passed to DataTable.
 */
export const getSortProps = (sortedColumn, columns) => {
  const sortBy = sortedColumn.replace(/^-/, '')
  const idx = columns.findIndex((c) => c.sortBy === sortBy)
  return {
    defaultSortFieldId: idx !== -1 ? columns[idx].id || idx + 1 : undefined,
    defaultSortAsc: !sortedColumn.startsWith('-'),
  }
}
